import { Dispatch, SetStateAction, useCallback } from "react";
import { Table } from "@tanstack/react-table";

interface IuseTableKeyboardNavigationProps<T> {
	table: Table<T>;
	focusedCell: { row: number; column: number };
	setFocusedCell: Dispatch<SetStateAction<{ row: number; column: number }>>;
	handleSubmit: () => void;
}

const useTableKeyboardNavigation = <T>({ table, focusedCell, setFocusedCell, handleSubmit }: IuseTableKeyboardNavigationProps<T>) => {
	const keyDownHandler = useCallback(
		(e: React.KeyboardEvent<HTMLDivElement | HTMLSelectElement>) => {
			if (!e.ctrlKey) return;

			const visibleRows = table.getRowModel().rows;
			const currentIndex = visibleRows.findIndex((row: any) => row.id === `${focusedCell?.row}`);

			switch (e.code) {
				case "ArrowDown": {
					const nextRow = visibleRows[currentIndex + 1];
					if (nextRow) {
						setFocusedCell({ row: Number(nextRow.id), column: focusedCell.column });
					}
					break;
				}
				case "ArrowUp": {
					const prevRow = visibleRows[currentIndex - 1];
					if (prevRow) {
						setFocusedCell({ row: Number(prevRow.id), column: focusedCell.column });
					}
					break;
				}
				case "ArrowRight": {
					setFocusedCell((prev) => ({ row: prev.row, column: (prev.column || 0) + 1 }));
					break;
				}
				case "ArrowLeft": {
					setFocusedCell((prev) => ({ row: prev.row, column: (prev.column || 0) - 1 }));
					break;
				}
				case "Enter": {
					handleSubmit();
					break;
				}
				case "Escape": {
					e.preventDefault();
					e.stopPropagation();

					break;
				}
			}
		},
		[table, focusedCell, setFocusedCell, handleSubmit]
	);

	return { keyDownHandler };
};

export default useTableKeyboardNavigation;
